import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import BackHeader from "../components/hub/BackHeader";

const VaultHub = () => {
  const { travelKeyToken } = useParams();
  const navigate = useNavigate();

  const sections = [
    { title: "Uplode Documents", icon: "📄", desc: "Passports, visas, insurance", route: "documents" },
    { title: "Add Tickets", icon: "🎫", desc: "Flights, trains, buses", route: "tickets" },
    { title: "Add your stay", icon: "🏨", desc: "Hotel bookings & stays", route: "stays" },
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 pb-20">

      <BackHeader
        title="Vault"
        onBack={() => navigate(`/trip/${travelKeyToken}`)}
      />

      <div className="mt-6 mb-10">
        <h1 className="text-3xl font-black text-gray-900 mb-2">
          Your Vault 🔐
        </h1>
        <p className="text-gray-500 font-medium">
          Everything important. One secure place.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {sections.map((item, i) => (
          <div
            key={i}
            onClick={() =>
              navigate(`/trip/${travelKeyToken}`, {
                state: { tab: item.route }
              })
            }
            className="group cursor-pointer bg-white border border-gray-100 rounded-3xl p-6 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all"
          >
            <div className="text-4xl mb-4">{item.icon}</div>
            <h3 className="text-lg font-bold text-gray-900 mb-1">
              {item.title}
            </h3>
            <p className="text-sm text-gray-500">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VaultHub;